import 'bootstrap/dist/css/bootstrap.css';
import React, { useState, useEffect, useContext } from 'react';
import { Context } from "../contexts/siteContext";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardBody from "../card/cardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import {
    Container, createMuiTheme, Toolbar, Typography, FormLabel, CssBaseline, Radio, RadioGroup,
    FormControlLabel, Checkbox, Button, TextField, Snackbar
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import 'date-fns';
import { ThemeProvider } from '@material-ui/styles';
import { GlobalTheme } from '../../layouts/theme';
import { Link } from "react-router-dom";
import { ConvertToCurrentTimeZone, ConvertTimeToUTC } from '../header/timeFormatter';
import moment from 'moment';
import { Typeahead } from 'react-bootstrap-typeahead';
import DateFnsUtils from '@date-io/date-fns';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import { HttpService } from "../../apiAuthorization/httpService";
import clipBoard from '../../images/teamlead_clipboard.png';
import data from '../../data';
import { authenticationService } from '../../apiAuthorization/authenticationService';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import MuiAlert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ServiceRecoveryList from '../serviceRecovery/serviceRecoveryList';
import { Modules } from '../contexts/modulesContext';
import { AssignedToUsers } from '../contexts/assignedToUsers';
import { Theme } from '../contexts/themeContext';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '10px 0px',
            width: '100%',
        },
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        // right: 0,
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        // position: 'absolute',
        marginTop: '-5px',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function VisitaionLogList(props) {
    //console.log("retunrned from tp " + props.returnFromTP );
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const { modules } = useContext(Modules);
    const recoveryButtonVisible = modules === undefined ? false : modules.includes("ServiceRecovery");
    const [selectedDate, setSelectedDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite));
    const [selected, setSelected] = useState(props.siteLocation ? props.siteLocation : []);
    const [locations, setLocations] = useState([]);
    const [patientName, setPatientName] = useState('');
    const [patientRequest, setPatientRequest] = useState([]);
    const [comment, setComment] = useState('');
    const [satisfied, setSatisfied] = useState('');
    const [housekeepers, setHousekeepers] = useState('');
    const [newAdmissionVisit, setNewAdmissionVisit] = useState(false);
    const [open, setOpen] = useState(false);
    const [appVisitId, setAppVisitId] = useState(0);
    const [saved, setSaved] = useState(props.siteLocation ? true : false);
    const [radio, setRadio] = useState(false);
    const [radio1, setRadio1] = useState(false);
    const [defaultManager, setDefaultManager] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [forceOpen, setForceOpen] = useState((props.returnFromSR || props.returnFromTP)? true : undefined);
   // const [successMessage, setSuccessMessage] = useState(props.returnFromSR ? 'The record added successfully':'');
   // const [openSuccess, setOpenSuccess] = useState(props.returnFromSR ? true : false);
    const [successMessage, setSuccessMessage] = useState('');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [showRecovery, setShowRecovery] = useState(false);
    const [visitRecoveryId, setVsitRecoveryId] = useState((new Date()).getTime());
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const [returnFromTP, setReturnFromTP] = useState(props.returnFromTP);

    //console.log("show recovery" + showRecovery);
    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseSuccess = () => {
        setOpenSuccess(false);
        setSelected([]);
        setSaved(false);
    };
    const validate = () => {
        if (patientRequest.length === 0) {
            setErrorMessage('Please select the patient requests.');
            setOpen(true);
            return false;
        }
        if (defaultManager.length === 0) {
            setErrorMessage('Please enter the manager assigned to.');
            setOpen(true);
            return false;
        }
        if (patientName.length === 0) {
            setErrorMessage('Please enter the patient name.');
            setOpen(true);
            return false;
        }
        if (satisfied === '') {
            setErrorMessage('Please check the satisfied.');
            setOpen(true);
            return false;
        }
        if (housekeepers === '') {
            setErrorMessage('Please check the housekeeper.');
            setOpen(true);
            return false;
        }
        return true;
    }

    const handleAdd = (e) => {
        if (validate()) {
            setBackDrop(true);
             HttpService.post('/VisitationLog/SaveAppVisit', {
                AppVisitId: parseInt(appVisitId),
                VisitDate: selectedDate,
                GeoLocationAncestorId: defaultSite.id,
                GeoLocationId: selected[0].id,
                AssignedTo: defaultManager[0].id,
                AssignedToName: defaultManager[0].firstName + " " + defaultManager[0].lastName,
                Comment: comment,
                Housekeepers: ((housekeepers === "true") ? true : false),
                Satisfied: ((satisfied === "true" ) ? true : false),
                NewAdmissionVisit: Boolean(newAdmissionVisit),
                CreatedUser: authenticationService.currentUserValue.username,
                ModifiedUser: authenticationService.currentUserValue.username,
                IsDeleted: Boolean(false),
                PatientRequests: patientRequest[0].name,
                PatientName: patientName,
                Create: appVisitId === 0 ? Boolean(true) : Boolean(false),
                ModifiedDateTime: appVisitId === 0 ? null : ConvertTimeToUTC(new Date()), // ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite),
                VisitRecoveryId: visitRecoveryId.toString(),
                //TransactionStartLocal = transactionStartLocal,
                //TransactionEndLocal = transactionEndLocal,
                //SessionDuration = sessionDuration,
                //WarningCount = warningCount,
            })
                 .then((result) => {
                     console.log("returned fromv" + props.returnFromSR + props.returnFromTP + showRecovery + result.data);
                     setAppVisitId(result.data.AppVisitId);
                    getListOfLocations();
                    setSaved(true);
                    setOpenSuccess(true);
                    setSuccessMessage("The reccord added successfully");
                    setForceOpen(true);
                     setBackDrop(false);
                     setReturnFromTP(false);
                },
                    (error) => {
                        console.log(error);
                        setBackDrop(false);
                    }
                );
        }
    }

    const handleDateChange = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a")
        setSelectedDate(date);
    };

    const classes = useStyles();
    const getListOfLocations = () => {
        setBackDrop(true);
        HttpService.post('/VisitationLog/GetGeoLocationBranchVisits', {
            Date: selectedDate,
            Key: "GetAll",
            MaxId: -1,
            Site: defaultSite.id,
            GetAll: true
        })
            .then((result) => {
                //console.log("Locations : " + result.data)
                setLocations(result.data);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    }
    
    const viewPatient = (patient) => {
        setBackDrop(true);
        HttpService.post("/VisitationLog/GetAppVisit", {
            AppVisitId: parseInt(patient.AppVisitId),
            VisitDate: selectedDate,
        }).then((result) => {
            var info = result.data;
            console.log(info);
            setPatientName(info.PatientName);
            setComment(info.Comment);
            setAppVisitId(info.AppVisitId);
            var index = data.patientRequestsData.findIndex(x => (x.name === info.PatientRequests));
            setPatientRequest(data.patientRequestsData.slice(index, index + 1));
            index = assignedUsers.findIndex(x => x.id === info.AssignedTo);
            setNewAdmissionVisit(info.NewAdmissionVisit)
            setRadio(false);
            setRadio1(false);
            setHousekeepers(info.Housekeepers ? "true" : "false");
            setSatisfied(info.Satisfied ? "true":"false");
            setDefaultManager(assignedUsers.slice(index, index + 1));
            setVsitRecoveryId(info.VisitRecoveryId);
            setSaved(false);
            setForceOpen(undefined);
            setBackDrop(false);
        },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
    }

    const locationChanged = (e) => {
        setSelected(e);
        setForceOpen(undefined);
        setPatientName('');
        setPatientRequest([]);
        setNewAdmissionVisit(false)
        setRadio(false);
        setRadio1(false);
        setHousekeepers("false");
        setSatisfied("false");
        setDefaultManager([]);
        setComment('');
    }

    const goToRecovery = async () => {
       await handleAdd();

        setShowRecovery(true);
    }

    useEffect(() => {
        console.log("retunrned from tp " + props.returnFromTP + showRecovery);
        if (props.returnFromTP) {
            setSuccessMessage("A new task " + (props.taskNumber ? props.taskNumber : '') + " has been created successfully in HRC system");
            setOpenSuccess(props.returnFromTP ? true : false);
        }
        else if(props.returnFromSR){
            setSuccessMessage("A new record has been created successfully");
            setOpenSuccess(props.returnFromSR ? true : false);
        }
        getListOfLocations();
        if (assignedUsers.length === 0) getAssignedToUsers();

        // eslint-disable-next-line 
    }, [selectedDate]);

    
    return (
        <React.Fragment>
            {showRecovery && <ServiceRecoveryList theme={currentTheme} siteLocation={selected} appVisitId={appVisitId}
                visitRecoveryId={visitRecoveryId} patientName={patientName} comment={comment} calledFromVL={true} />}
            {(!showRecovery || returnFromTP === true)  && <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="visitBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={6000} onClose={handleCloseSuccess}>
                    <Alert onClose={handleCloseSuccess} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" style={{ height: '90%' }} className={props.styles}>

                    <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                        <CardHeader color="primary" style={{ background: currentTheme.palette.primary }} >
                            <div style={{ display: 'flex' }}>
                                <Toolbar style={{ width: '85%' }}>
                                    <Link to="/"><KeyboardBackspaceIcon /></Link>
                                    <Typography variant="h6" className={classes.title}>
                                        Patient Visitation Log
                                </Typography>
                                </Toolbar>
                                {selected.length > 0 && recoveryButtonVisible && <Button
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    className={classes.button}
                                    style={{ background: currentTheme.secondary, width: 'auto', margin: 'auto' }}
                                    //startIcon={<SaveIcon />}
                                    type="submit"
                                    onClick={goToRecovery}
                                >
                                    Recovery Log
                                        </Button>
                                }
                            </div>
                        </CardHeader>
                        <CardBody style={{ color: currentTheme.text }}>

                            <ValidatorForm className={classes.root} autoComplete="off" onSubmit={handleAdd}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker autoOk
                                        // variant="inline"
                                        inputVariant="outlined"
                                        label="Date"
                                        format="MM/dd/yyyy hh:mm a"
                                        size="small"
                                        disableFuture="true"
                                        value={selectedDate}
                                        InputAdornmentProps={{ position: "start" }}
                                        onChange={date => handleDateChange(date)}
                                    />
                                </MuiPickersUtilsProvider>

                                <Typeahead
                                    id="basic-typeahead-example"
                                    labelKey="name"
                                    onChange={(e) => locationChanged(e)}
                                    options={locations}
                                    placeholder="Choose a Location..."
                                    selected={selected}
                                    open={forceOpen} // Forced to keep it open drop down after saving
                                    renderMenuItemChildren={(option, key) => (
                                        <>
                                            <div className="dropdown-widget">
                                                <div className="left">{option.name}</div>
                                                <div className="round-tags swiper-wrapper width-auto">
                                                    {option.patientNamesList.map((patient, key) => (
                                                        <img key={patient.AppVisitId} src={clipBoard} alt="edit" className="swiper-slide patientname-tag" onClick={() => viewPatient(patient)} />
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                />

                                {(selected.length > 0 && !saved) &&
                                    <>
                                        <FormLabel className="selLocation">Location : {selected[0].name}</FormLabel>
                                        <TextField
                                            label="Patient Last Name, First Initial"
                                            onChange={e => setPatientName(e.target.value)}
                                            name="email"
                                            required
                                            value={patientName}
                                            variant="outlined"
                                            size="small"
                                        />
                                        {/*<FormHelperText className={classes.error}>{patientNameError}</FormHelperText> */}
                                        <Typeahead
                                            id="basic-example"
                                            labelKey="name"
                                            onChange={setPatientRequest}
                                            options={data.patientRequestsData}
                                            placeholder="Choose a Patient Request..."
                                            selected={patientRequest}
                                            defaultSelected={patientRequest}
                                            renderMenuItemChildren={(option, key) => (
                                                <div className="dropdown-widget">
                                                    <div className="left">{option.name}</div>
                                                </div>
                                            )}
                                        />
                                        <TextField
                                            label="Comment"
                                            onChange={e => setComment(e.target.value)}
                                            name="email"
                                            value={comment}
                                            variant="outlined"
                                            size="small"
                                        />
                                        <div style={{ display: 'flex' }}>
                                            <FormLabel component="legend" style={{ width: '40%' }}>The patient is satisfied with the level of cleanliness in the room and bathroom</FormLabel>
                                            <RadioGroup aria-label="cleanliness" name="cleanliness" value={satisfied} style={{ display: 'block', marginTop: '-12px' }}
                                                onChange={(e) => {
                                                    setSatisfied(e.target.value);
                                                    setRadio(true);
                                                }}>
                                            {!radio && <FormControlLabel value="true" control={<Radio required style={{ color: currentTheme.secondary }} />} checked={satisfied === "true"} label="Yes" />}
                                            {!radio && <FormControlLabel value="false" control={<Radio required style={{ color: currentTheme.secondary }} />} checked={satisfied === "false"} label="No" />}
                                            {radio && <FormControlLabel value="true" control={<Radio required style={{ color: currentTheme.secondary }}/>} label="Yes" />}
                                            {radio && <FormControlLabel value="false" control={<Radio required style={{ color: currentTheme.secondary }} />} label="No" />}
                                            </RadioGroup>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <FormLabel component="legend" style={{ width: '40%' }}>Housekeepers introduced themselves & explained their duties</FormLabel>
                                            <RadioGroup aria-label="housekeepers" name="housekeepers" value={housekeepers} style={{ display: 'block', marginTop: '-12px' }} onChange={(e) => {
                                                setHousekeepers(e.target.value);
                                                setRadio1(true);
                                            }}>
                                            {!radio1 && <FormControlLabel value="true" control={<Radio required style={{ color: currentTheme.secondary }}/>} checked={housekeepers === "true"} label="Yes" />}
                                            {!radio1 && <FormControlLabel value="false" control={<Radio required style={{ color: currentTheme.secondary }} />} checked={housekeepers === "false"} label="No" />}
                                            {radio1 && <FormControlLabel value="true" control={<Radio required style={{ color: currentTheme.secondary }} />} label="Yes" />}
                                            {radio1 && <FormControlLabel value="false" control={<Radio required style={{ color: currentTheme.secondary }} />} label="No" />}
                                            </RadioGroup>
                                        </div>
                                        <Typeahead
                                            id="labelkey-example"
                                            labelKey={(option) => `${option.firstName} ${option.lastName}`}
                                            onChange={setDefaultManager}
                                            options={assignedUsers}
                                            placeholder="Choose a Manager assigned..."
                                            selected={defaultManager}
                                            defaultSelected={defaultManager}
                                            renderMenuItemChildren={(option, key) => (
                                                <div className="dropdown-widget">
                                                    <div className="left">{option.firstName} {option.lastName}</div>
                                                </div>
                                            )}
                                        />
                                        {/*<FormHelperText className={classes.error}>{managerError}</FormHelperText> */}
                                        <FormControlLabel
                                            style={{ width: 'auto' }}
                                            value="start"
                                            control={<Checkbox style={{ color: currentTheme.secondary }} checked={newAdmissionVisit} />}
                                            label="New Admission Visit"
                                            labelPlacement="start"
                                            onChange={e => setNewAdmissionVisit(e.target.checked)}
                                        />
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            style={{ background: currentTheme.secondary, width: 'auto' }}
                                            startIcon={<SaveIcon />}
                                            type="submit"
                                        >
                                            Save
                                        </Button>
                                    </>
                                }
                            </ValidatorForm>
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
            }
        </React.Fragment>
    )
}